import { BasketParams } from './baskets.types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import adserver from 'services/adserver';
import { withErrorHandling } from 'store/wrappers';
import { REDUCER_KEY } from './baskets.consts';
import { selectCurrentCampaignId } from 'store/campaigns';

export const fetchBasketById = createAsyncThunk(
  REDUCER_KEY + '/fetchBasketById',
  withErrorHandling(async (basketId: number) => {
    const response = await adserver({
      url: `/basket/${basketId}`,
      headers: {},
    });
    return response.data;
  }),
);

export const fetchAllBasketsOfCampaign = createAsyncThunk(
  REDUCER_KEY + '/get',
  withErrorHandling(async ({ campaignId }: { campaignId: number }) => {
    const response = await adserver({
      url: `/campaign/${campaignId}/baskets`,
      headers: {},
    });

    return response.data.map((basket: BasketParams) => ({
      ...basket,
      campaignId,
    }));
  }),
);

export const fetchAllBasketsForCurrentCampaign = createAsyncThunk(
  REDUCER_KEY + '/fetchAllBasketsForCurrentCampaign',
  withErrorHandling(async (_: any, thunkApi: any) => {
    const campaignId = selectCurrentCampaignId(thunkApi.getState());
    const response = await adserver({
      url: `/campaign/${campaignId}/baskets`,
      headers: {},
    });

    return response.data.map((basket: BasketParams) => ({
      ...basket,
      campaignId,
    }));
  }),
);

export const submit = createAsyncThunk(
  REDUCER_KEY + '/update',
  withErrorHandling(async (basket: BasketParams) => {
    const response = await adserver({
      url: `/basket/${basket.id}/order/submit`,
      method: 'POST',
      headers: {},
      data: basket,
    });
    return response.data;
  }),
);

export const removeAllBaskets = (): { type: string } => ({
  type: REDUCER_KEY + '/removeAll',
});

export const activateDraftMode = createAsyncThunk(
  REDUCER_KEY + '/activate',
  withErrorHandling(async (basketId: number) => {
    const response = await adserver({
      url: `/basket/${basketId}/draftmode/activate`,
      method: 'POST',
      headers: {},
    });
    return response.data;
  }),
);

export const commitDraftMode = createAsyncThunk(
  REDUCER_KEY + '/commit',
  withErrorHandling(async (basketId: number) => {
    const response = await adserver({
      url: `/basket/${basketId}/draftmode/commit`,
      method: 'POST',
      headers: {},
    });
    return response.data;
  }),
);

export const discardDraftMode = createAsyncThunk(
  REDUCER_KEY + '/discard',
  withErrorHandling(async (basketId: number) => {
    const response = await adserver({
      url: `/basket/${basketId}/draftmode/discard`,
      method: 'POST',
      headers: {},
    });
    return response.data;
  }),
);
